<div class="row narrow-gutters align-items-center position-relative">
  <div class="col" (change)="refresh()">
    <ng-content></ng-content>
  </div>
  @if (status && status.tidalShip) {
    <div class="col-auto position-absolute" style="right: 1rem">
      <app-tooltip [wide]="true">
        <span class="fa text-info fa-fw"
              [ngClass]="status.tidalWindowType === 'ASTRO' ? 'fa-satellite-dish' : 'fa-water'"></span>
        <div class="tooltipContent">
          <div class="mb-2">
            Please select a time in one of the tidal windows:
          </div>
          @for (window of status.tidalWindows; track window) {
            <div class="my-1">
              <app-formatted-date-range [start]="window.start" [end]="window.end"></app-formatted-date-range>
            </div>
          }
          @if (status.remarks) {
            <div>
              Harbour master remarks: {{ status.remarks }}
            </div>
          }
          @if (status.tidalWindowType === 'ASTRO') {
            <div>
              <div>These tidal windows are based on astro data and are indicative</div>
              <div>No rights can be derived from this information</div>
            </div>
          }
          @if (status.tidalWindowType === 'ACTUAL') {
            <div>
              This tidal window has been determined by HCC
            </div>
          }
        </div>
      </app-tooltip>
    </div>
  }
</div>
